import { useLoaderData } from "react-router-dom";

import { useVideos } from "../hooks/useVideos";
import VideoCard from "../components/card/VideoCard";
import CardGrid from "../components/card/CardGrid";
import { useEffect, useState } from "react";
import classNames from "classnames";
import useInfiniteScroll from "../hooks/useInfiniteScroll";
import PlaceholderCard from "../components/card/PlaceholderCard";
import { range } from "../lib/range";

import placeholderImage from "../assets/images/placeholder.jpg";

interface LoaderResult {
    channelURL: string;
}

export function loader({ params }: any) {
    return { channelURL: `/${params.sub}/${params.channel}` };
}

export default function Channel() {
    const { channelURL } = useLoaderData() as LoaderResult;
    const [videosResult, order, setOrder, isLoading, loadMore] =
        useVideos(channelURL);
    const hasReachedEnd = useInfiniteScroll(300);

    useEffect(() => {
        if (videosResult) {
            document.title =
                "Estrela Pornô - " + videosResult.channelInfo.title;
        } else {
            document.title = "Estrela Pornô";
        }
    }, [videosResult]);

    useEffect(() => {
        if (videosResult && hasReachedEnd) loadMore();
    }, [hasReachedEnd]);

    return (
        <div className="flex w-11/12 flex-col gap-8">
            <div className="not:md:grid-rows-2 grid gap-8 md:grid-cols-2">
                <div className="flex gap-2">
                    <img
                        className="w-16"
                        src={videosResult?.channelInfo.img || placeholderImage}
                        alt="Image do canal"
                    />
                    <div className="flex flex-col gap-1">
                        <h1
                            className={classNames("text-lg font-medium", {
                                "mt-1 h-4 w-48 animate-pulse bg-xv-placeholder-bg motion-reduce:animate-none":
                                    videosResult === null,
                            })}
                        >
                            {videosResult?.channelInfo.title}
                        </h1>
                        <h2
                            className={classNames("text-sm", {
                                "mt-2 h-3 w-24 animate-pulse bg-xv-placeholder-bg motion-reduce:animate-none":
                                    videosResult === null,
                            })}
                        >
                            {videosResult?.channelInfo.details}
                        </h2>
                    </div>
                </div>
                <p>
                    Para copiar o link do vídeo, basta clicar no vídeo que quer
                    assistir, depois colar na conversa com o Robozinho no{" "}
                    <a
                        className="underline hocus:brightness-90"
                        href="https://T.me/RobozinhoDoXVIDEOS_BOT"
                    >
                        Telegram
                    </a>
                    .
                </p>
            </div>
            <div className="flex flex-wrap gap-2">
                <button
                    className={classNames(
                        "rounded-full px-4 py-2 font-medium hover:brightness-90",
                        { "bg-xv-chip-bg": order !== "new" },
                        {
                            "bg-xv-active-chip-bg text-xv-active-chip-text":
                                order === "new",
                        }
                    )}
                    onClick={() => setOrder("new")}
                >
                    Novo
                </button>

                <button
                    className={classNames(
                        "rounded-full px-4 py-2 font-medium hover:brightness-90",
                        { "bg-xv-chip-bg": order !== "most-viewed" },
                        {
                            "bg-xv-active-chip-bg text-xv-active-chip-text":
                                order === "most-viewed",
                        }
                    )}
                    onClick={() => setOrder("most-viewed")}
                >
                    Mais Vistos
                </button>
            </div>
            <CardGrid>
                {[
                    ...(videosResult
                        ? videosResult.videos.map((video, i) => (
                              <VideoCard key={i} {...video} />
                          ))
                        : []),

                    ...(isLoading
                        ? range(0, 8).map((i) => <PlaceholderCard key={i} />)
                        : []),
                ]}
            </CardGrid>
        </div>
    );
}
